import { render } from "./StandardFooter.vue?vue&type=template&id=052a3360"
import script from "./StandardFooter.vue?vue&type=script&lang=js"
export * from "./StandardFooter.vue?vue&type=script&lang=js"

import "./StandardFooter.vue?vue&type=style&index=0&id=052a3360&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__